import Comments from "src/containers/Comments";

export default Comments;
